import $ from 'cash-dom';
import EmblaCarousel from 'embla-carousel';
import { setupPrevNextBtns, disablePrevNextBtns } from "./slider-buttons";
import { setupDotBtns, generateDotBtns, selectDotBtn } from "./embla-dot-helpers";

$(function () {
    if ($('.home-inline-features').length != 0) {
        if (window.innerWidth <= 767) {
            const allSliders = document.querySelectorAll('.home-inline-features');

            allSliders.forEach(function(val, index) {
                const sliderParent = allSliders[index];
                const sliderNode =  sliderParent.querySelector('.embla');

                const options = {
                    loop: false,
                    align: 'center',
                    containerSelector: '.embla__container'
                };

                const prevSlide = sliderParent.querySelector(".embla__button--prev");
                const nextSlide = sliderParent.querySelector(".embla__button--next");

                const slider = EmblaCarousel(sliderNode, options)
                const disablePrevAndNextBtns = disablePrevNextBtns(prevSlide, nextSlide, slider);
                const dotsFeatured = sliderParent.querySelector('.embla__dots');
                let dotsFeaturedArr = generateDotBtns(dotsFeatured, slider);
                let setSelectedDotBtn = selectDotBtn(dotsFeaturedArr, slider);

                setupDotBtns(dotsFeaturedArr, slider);
                slider.on('select', setSelectedDotBtn);
                slider.on('init', setSelectedDotBtn);

                setupPrevNextBtns(prevSlide, nextSlide, slider);
                slider.on('select', disablePrevAndNextBtns);
                slider.on('init', disablePrevAndNextBtns);

            })
        }
    }
})